module.exports = __webpack_public_path__ + "img/map-left-flag.80ded52f.svg";